import { render, staticRenderFns } from "./OurValuesList.vue?vue&type=template&id=8fbc2d4e&"
import script from "./OurValuesList.vue?vue&type=script&lang=ts&"
export * from "./OurValuesList.vue?vue&type=script&lang=ts&"
import style0 from "./OurValuesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports